export const FETCH_CARE_HEARTH_ENQUIRIES = "app/CareHearth/FETCH_ENQUIRIES";
export const FETCH_CARE_HEARTH_ENQUIRIES_SUCCESS =
  "app/CareHearth/FETCH_ENQUIRIES_SUCCESS";
export const FETCH_CARE_HEARTH_ENQUIRIES_FAILURE =
  "app/CareHearth/FETCH_ENQUIRIES_FAILURE";

export const FETCH_CARE_HEARTH_ENQUIRY = "app/CareHearth/FETCH_ENQUIRY";
export const FETCH_CARE_HEARTH_ENQUIRY_SUCCESS =
  "app/CareHearth/FETCH_ENQUIRY_SUCCESS";
export const FETCH_CARE_HEARTH_ENQUIRY_FAILURE =
  "app/CareHearth/FETCH_ENQUIRY_FAILURE";

export const FETCH_CARE_HEARTH_AUDIT_EVENTS =
  "app/CareHearth/FETCH_AUDIT_EVENTS";
export const FETCH_CARE_HEARTH_AUDIT_EVENTS_SUCCESS =
  "app/CareHearth/FETCH_AUDIT_EVENTS_SUCCESS";
export const FETCH_CARE_HEARTH_AUDIT_EVENTS_FAILURE =
  "app/CareHearth/FETCH_AUDIT_EVENTS_FAILURE";

export const FIND_CARE_HEARTH_ELIGIBLE_HOMES =
  "app/CareHearth/FIND_ELIGIBLE_HOMES";
export const FIND_CARE_HEARTH_ELIGIBLE_HOMES_SUCCESS =
  "app/CareHearth/FIND_ELIGIBLE_HOMES_SUCCESS";
export const FIND_CARE_HEARTH_ELIGIBLE_HOMES_FAILURE =
  "app/CareHearth/FIND_ELIGIBLE_HOMES_FAILURE";

export const CREATE_CARE_HEARTH_OFFERS = "app/CareHearth/CREATE_OFFERS";
export const CREATE_CARE_HEARTH_OFFERS_SUCCESS =
  "app/CareHearth/CREATE_OFFERS_SUCCESS";
export const CREATE_CARE_HEARTH_OFFERS_FAILURE =
  "app/CareHearth/CREATE_OFFERS_FAILURE";

export const UPDATE_CARE_HEARTH_LIFECYCLE = "app/CareHearth/UPDATE_LIFECYCLE";
export const UPDATE_CARE_HEARTH_LIFECYCLE_SUCCESS =
  "app/CareHearth/UPDATE_LIFECYCLE_SUCCESS";
export const UPDATE_CARE_HEARTH_LIFECYCLE_FAILURE =
  "app/CareHearth/UPDATE_LIFECYCLE_FAILURE";

export const UPDATE_CARE_HEARTH_VERIFICATION =
  "app/CareHearth/UPDATE_VERIFICATION";
export const UPDATE_CARE_HEARTH_VERIFICATION_SUCCESS =
  "app/CareHearth/UPDATE_VERIFICATION_SUCCESS";
export const UPDATE_CARE_HEARTH_VERIFICATION_FAILURE =
  "app/CareHearth/UPDATE_VERIFICATION_FAILURE";

// Disputes (15 October 2026): approve voids the enquiry, reject is final.
export const DECIDE_CARE_HEARTH_DISPUTE = "app/CareHearth/DECIDE_DISPUTE";
export const DECIDE_CARE_HEARTH_DISPUTE_SUCCESS =
  "app/CareHearth/DECIDE_DISPUTE_SUCCESS";
export const DECIDE_CARE_HEARTH_DISPUTE_FAILURE =
  "app/CareHearth/DECIDE_DISPUTE_FAILURE";

// Not sent (15 October 2026): /find searches whose family kept "Send my
// enquiry" off. Our team calls them and can start an enquiry for them.
export const FETCH_CARE_HEARTH_SEARCHES = "app/CareHearth/FETCH_SEARCHES";
export const FETCH_CARE_HEARTH_SEARCHES_SUCCESS =
  "app/CareHearth/FETCH_SEARCHES_SUCCESS";
export const FETCH_CARE_HEARTH_SEARCHES_FAILURE =
  "app/CareHearth/FETCH_SEARCHES_FAILURE";

export const RECORD_CARE_HEARTH_SEARCH_CALL =
  "app/CareHearth/RECORD_SEARCH_CALL";
export const RECORD_CARE_HEARTH_SEARCH_CALL_SUCCESS =
  "app/CareHearth/RECORD_SEARCH_CALL_SUCCESS";
export const RECORD_CARE_HEARTH_SEARCH_CALL_FAILURE =
  "app/CareHearth/RECORD_SEARCH_CALL_FAILURE";

export const START_CARE_HEARTH_SEARCH_ENQUIRY =
  "app/CareHearth/START_SEARCH_ENQUIRY";
export const START_CARE_HEARTH_SEARCH_ENQUIRY_SUCCESS =
  "app/CareHearth/START_SEARCH_ENQUIRY_SUCCESS";
export const START_CARE_HEARTH_SEARCH_ENQUIRY_FAILURE =
  "app/CareHearth/START_SEARCH_ENQUIRY_FAILURE";

export const CLEAR_CARE_HEARTH_FEEDBACK = "app/CareHearth/CLEAR_FEEDBACK";
